// Variant pills on product cards (snippets/card-variants.liquid): colors, and
// words for other options (the Food Cart top's FOOD / TEXT).
//
// A tap on a pill selects it: the card shows that value's photo, its links go
// to the value's first variant, and the pill is marked. The pill marked
// data-default is the card as it came: picking it puts the cover (a video
// cover included) and the links back. With a mouse, hovering a pill previews
// its photo and leaving the pills puts the selected one back. A card whose
// cover is a video shows a picked photo over the paused video. A card showing
// another value keeps that photo on hover rather than fading to its second
// image, which belongs to the default. Delegated from the document, so cards
// that a filter or a recommendation brings in later work without setup.
(function () {
  if (window.cardVariantsReady) return;
  window.cardVariantsReady = true;

  var OPTION = '.card-variants__pill';

  function parts(el) {
    var card = el.closest('.card-wrapper');
    var box = card && card.querySelector('.card-variants');
    var media = card && card.querySelector('.card__media .media');
    return card && box && media ? { card: card, box: box, media: media } : null;
  }

  // Show a photo (srcset/src) on the card; null puts the card's own cover back.
  function show(p, srcset, src) {
    var img = p.media.querySelector(':scope > img:not(.card-variants__still)');
    var video = p.media.querySelector(':scope > video');
    if (img) {
      img.srcset = srcset || p.box.dataset.defaultSrcset;
      img.src = src || p.box.dataset.defaultSrc;
      return;
    }
    if (!video) return;
    var still = p.media.querySelector('.card-variants__still');
    if (!srcset) {
      if (still) still.remove();
      video.style.visibility = '';
      if (video.paused) video.play().catch(function () {});
      return;
    }
    if (!still) {
      still = document.createElement('img');
      still.className = 'card-variants__still motion-reduce';
      still.alt = '';
      still.sizes = '(min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)';
      p.media.appendChild(still);
    }
    still.srcset = srcset;
    still.src = src;
    video.pause();
    video.style.visibility = 'hidden';
  }

  function mark(p, picked) {
    p.box.querySelectorAll(OPTION).forEach(function (option) {
      var on = option === picked;
      option.classList.toggle('is-active', on);
      option.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function link(p, href) {
    p.card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      a.href = href;
    });
  }

  document.addEventListener('click', function (event) {
    var option = event.target.closest && event.target.closest(OPTION);
    if (!option) return;
    event.preventDefault();
    event.stopPropagation();
    var p = parts(option);
    if (!p) return;
    mark(p, option);
    if ('default' in option.dataset) {
      show(p, null, null);
      link(p, p.box.dataset.defaultHref);
      p.card.classList.remove('is-variant-picked');
      return;
    }
    show(p, option.dataset.srcset, option.dataset.src);
    if (option.dataset.href) link(p, option.dataset.href);
    p.card.classList.add('is-variant-picked');
  });

  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.addEventListener('mouseover', function (event) {
    var pill = event.target.closest && event.target.closest('.card-variants__pill');
    var p = pill && parts(pill);
    if (!p || !pill.dataset.srcset) return;
    p.card.classList.add('is-variant-previewing');
    if ('default' in pill.dataset) show(p, null, null);
    else show(p, pill.dataset.srcset, pill.dataset.src);
  });

  document.addEventListener('mouseout', function (event) {
    var pills = event.target.closest && event.target.closest('.card-variants__pills');
    if (!pills || pills.contains(event.relatedTarget)) return;
    var p = parts(pills);
    if (!p) return;
    p.card.classList.remove('is-variant-previewing');
    var active = pills.querySelector('.card-variants__pill.is-active');
    if (!active || 'default' in active.dataset) show(p, null, null);
    else show(p, active.dataset.srcset, active.dataset.src);
  });
})();
